import React from "react";
import { useDispatch } from "react-redux";

import Title from "../../../../uiKit/Title/Title";
import { blue300 } from "../../../../uiKit/assets/colors/colors";

import { setDonationFormOpen } from "../../../../redux/state/donationSlice";

const NoDonations = () => {
    const dispatch = useDispatch();

    const openFormHandler = () => dispatch(setDonationFormOpen(true));

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column'
        }}>
            <Title
                text="This campaign haven't received any donations yet."
                fontSize={16}
                lineHeight={24}
                fontWeight={400}
            />
            <Title
                text='Donate to campaign'
                fontSize={16}
                lineHeight={24}
                fontWeight={400}
                color={blue300}
                style={{ cursor: 'pointer' }}
                onClick={openFormHandler}
            />
        </div>
    )
}

export default NoDonations;